/**
 * @author        russell@zumper.com (Russell Middleton)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Marketing tracking
 */

import Marketing from './marketing'

export default new Marketing()
